import { useRef } from 'react';
import { useSignal, useCallback, untrack } from '@ai-indeed/react-signal';

export const useCountdown = (duration = 60) => {
  // state
  const [second, setSecond] = useSignal(-1);
  // ref
  const rafRef = useRef(-1);
  // methods
  const start = useCallback(() => {
    const start = performance.now();
    const reckon = () => {
      rafRef.current = requestAnimationFrame((tick) => {
        const seconds = duration - Math.floor((tick - start) / 1000);
        if (seconds > 0) {
          if (seconds !== untrack(() => second())) {
            setSecond(seconds);
          }
          reckon();
        } else {
          setSecond(-1);
        }
      });
    };
    if (rafRef.current !== -1) {
      cancelAnimationFrame(rafRef.current);
      rafRef.current = -1;
    }
    setSecond(duration);
    reckon();
  });
  return [second, start] as const;
};
